import { render, staticRenderFns } from "./PropertyEditor.vue?vue&type=template&id=2157488a&scoped=true&lang=pug&"
import script from "./PropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./PropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyEditor.vue?vue&type=style&index=0&id=2157488a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157488a",
  null
  
)

export default component.exports